<template>
  <div class="chips">
    <div v-if="label" class="chips__label">{{ label }}</div>
    <div :class="['chips__inner', { chips__inner_has_border: hasBorder }]">
      <!-- v-if="itemsNamesLength" -->
      <Container
        @drop="handleItemDrop"
        @drag-end="handleDragEnd"
        :class="[
          'chips__items',
          { chips__items_direction_column: isDirectionColumn },
        ]"
        :behaviour="behaviour"
        :drag-class="behaviour === 'move' ? 'chips-ghost-drag' : undefined"
        :drop-class="behaviour === 'move' ? 'chips-ghost-drop' : undefined"
        :animation-duration="animationDuration"
        :orientation="isDirectionColumn ? 'vertical' : 'horizontal'"
        :get-child-payload="getChildPayload"
      >
        <span
          v-if="itemsNamesLength === 0 && placeholder"
          class="chips__placeholder"
        >
          {{ placeholder }}
        </span>
        <Draggable
          v-for="(itemName, index) in itemsNames"
          class="chips__item"
          :key="index"
          ref="chips"
        >
          <Chip
            @click.stop="handleItemClick(index)"
            @iconClick="handleItemIconClick(index)"
            :background="colorChip"
            :clickable="itemClickable"
            :icon="icon"
            :hover-color="hoverColor"
            :value="itemName"
          >
            <template #iconChip>
              <slot name="icon" :item="items[index]"></slot>
            </template>
          </Chip>
        </Draggable>
        <Chip
          v-if="defaultItem"
          @click.stop="handleItemClick()"
          class="chips__item_type_default"
          :background="colorChip"
          :clickable="itemClickable"
          :has-icon="false"
          :value="defaultItem"
      /></Container>
    </div>
  </div>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd';

import { processDragResult } from '@/shared/helpers';

import Chip from './../Chip';

export default {
  name: 'Chips',
  components: { Chip, Container, Draggable },
  props: {
    /* Name of default chip */
    defaultItem: { default: '', type: String },
    /* Field used to identify item */
    fieldId: { default: '', type: String },
    /* Field used to be label */
    fieldName: { default: '', type: String },
    /* Has chips inner border or not */
    hasBorder: { default: true, type: Boolean },
    /* Defines are items located vertically */
    isDirectionColumn: { default: false, type: Boolean },
    /* Array with chips names */
    items: { default: () => [], type: Array },
    /* Is chip item clickable */
    itemClickable: { default: true, type: Boolean },
    /* Additional label */
    label: { default: '', type: String },
    /* Right side icon */
    icon: { default: 'cancel', type: String },
    /* right side icon color */
    hoverColor: { default: 'var(--color-1)', type: String },
    /* Color chip */
    colorChip: { default: 'var(--color-1)', type: String },
    /* container behaviour https://github.com/amendx/vue-dndrop#properties */
    behaviour: { default: 'contain', type: String },
    /* Chips placeholder */
    placeholder: { default: '', type: String },
    /* animationDuration */
    animationDuration: { default: 250, type: Number },
  },
  emits: {
    input: null,
    itemClick: null,
    itemIconClick: null,
    dragStarted: null,
    dragEnded: null,
  },
  computed: {
    itemsNames() {
      const fieldName = this.fieldName;

      return fieldName ? this.items.map(i => i[fieldName]) : this.items;
    },
    itemsNamesLength() {
      return this.itemsNames?.length;
    },
  },
  methods: {
    handleItemClick(index) {
      const chipsRef = this.$refs.chips;
      this.$emit('itemClick', index, chipsRef[index]);
    },
    handleItemDrop(dropResult) {
      const newItems = processDragResult(this.items, dropResult);
      const fieldId = this.fieldId;
      this.$emit('input', fieldId ? newItems.map(i => i[fieldId]) : newItems);
    },
    handleItemIconClick(index) {
      this.$emit('itemIconClick', index);
    },
    handleDragEnd(dragResult) {
      this.$emit('dragEnded', dragResult);
    },
    getChildPayload(index) {
      const payload = {
        typeId: this.fieldId,
        idx: index,
        ...this.items[index],
      };
      this.$emit('dragStarted', payload);
      return payload;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Chips';
</style>
